/* eslint-disable @next/next/no-img-element */
import React, { useEffect, useState } from "react";
import { Popover, PopoverBody, PopoverHeader, Button } from "reactstrap";
import { selectBackgroundColor, selectedImage } from "../../Redux/uploadFile/UploadFileSLice";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const ColorPopover = ({ popoverId, buttonLabel }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [popoverOpen, setPopoverOpen] = useState(false);
  const [selectedColor, setSelectedColor] = useState(null);
  const selectedImages = useSelector(selectedImage);
  const togglePopover = () => {
    setPopoverOpen(!popoverOpen);
  };
  const colors = [
    "#ED6E1C",
    "#273240",
    "#D10000",
    "#FFC145",
    "#038B00",
    "#175CCC",
    "#FF2FC5",
    "#CAAA00",
  ];

  useEffect(() => {
    dispatch(selectBackgroundColor(selectedColor));
    setSelectedColor(selectedColor);
  }, [dispatch,selectedColor]);
  const handleDone = async () => {
    setPopoverOpen(false);
  };
  return (
    <>
      <div 
        className="customBox" 
        id="colorPopover"
        onClick={togglePopover}
        data-text={t('addBackgroundPage.buttons.color')}
      >
        <div>
          <Button className="customActionButton" style={{background: selectedImages ? "linear-gradient(45deg, #ed6e1c, #ffb65a)" :selectedColor }}>
            <img
              src="/images/AddBG/Color Brush 2.svg"
              className="buttinIcon"
              style={{ padding: "5px" }}
              alt="brush image"
            />
          </Button>
        </div>
        <div>
          <label id={popoverId}>{buttonLabel}</label>
        </div>{" "}
      </div>
      <Popover
        placement="bottom"
        isOpen={popoverOpen}
        trigger="legacy"
        target={"colorPopover"}
        toggle={togglePopover}
      >
        <PopoverHeader> {t('addBackgroundPage.tooltips.selectColor')}</PopoverHeader>
        <PopoverBody>
          <div className="colorOptions">
            <div
              className="colorBox"
              style={{ position: "relative", cursor: "pointer" }}
              onClick={() => setSelectedColor(null)}
            >
              <img
                src="/images/AddBG/emptyImg.svg"
                alt="empty"
                style={{ position: "absolute", top: "25%", left: "25%" }}
              />
            </div>
            {colors.map((item, index) => (
              <div
                key={"color" + index}
                className={`colorBox ${
                  selectedColor === item ? "selected" : ""
                }`}
                onClick={() => setSelectedColor(item)}
                style={{
                  cursor: "pointer",
                  backgroundColor: item,
                  boxShadow:
                    selectedColor === item
                      ? "0 0 0 3px white, 0 0 0 5px blue"
                      : "",
                }}
              ></div>
            ))}{" "}
            {/* Add more colors as needed */}
          </div>
          <div className="popover-buttons">
            <button
              className="resetButton"
              onClick={() => setSelectedColor(null)}
            >
         {   t('addBackgroundPage.buttons.reset')}
            </button>
            <button className="doneButton" onClick={handleDone}>
              {t('addBackgroundPage.buttons.add')}
            </button>
          </div>
        </PopoverBody>
      </Popover>
    </>
  );
};

export default ColorPopover;
